import { axiosApi } from './index';
import { types, API_URL } from './types';

export const getVersionsByModel = (modelId) => {
  const url = `${API_URL}/api/v1/model/${modelId}/version`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.get(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = 'Error al obtener versiones';
        dispatch(setGetVersions(outputData));
      } else {
        outputData['data'] = data.data;
        outputData['message'] = data.message;
        dispatch(setGetVersions(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setGetVersions({ status: 'danger', error: true, message }));
      });
  };
};

export const setGetVersions = (data) => ({
  type: types.bmGetVersions,
  payload: data,
});

export const createVersion = (modelId, name) => {
  const url = `${API_URL}/api/v1/model/${modelId}/version/create`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.post(url, { name }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setCreateVersion(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        dispatch(setCreateVersion(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setCreateVersion({ status: 'danger', error: true, message }));
      });
  };
};

export const setCreateVersion = (data) => ({
  type: types.bmCreateVersion,
  payload: data,
});

export const updateVersion = (versionId, name) => {
  const url = `${API_URL}/api/v1/version/edit/${versionId}`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.put(url, { name }).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setUpdateVersion(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        dispatch(setUpdateVersion(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setUpdateVersion({ status: 'danger', error: true, message }));
      });
  };
};

export const setUpdateVersion = (data) => ({
  type: types.bmUpdateVersion,
  payload: data,
});

export const deleteVersionById = (versionId) => {
  const url = `${API_URL}/api/v1/version/${versionId}`;

  return (dispatch) => {
    let outputData = {};

    axiosApi.delete(url).then(({ data }) => {
      if (data.error) {
        outputData['status'] = 'danger';
        outputData['message'] = data.message;
        dispatch(setDeleteVersionById(outputData));
      } else {
        outputData['status'] = 'success';
        outputData['message'] = data.message;
        dispatch(setDeleteVersionById(outputData));
      }
    })
      .catch((error) => {
        const status = error.response?.status;
        const message =
          status === 403 ? 'No tienes permisos para esta acción.' :
          status === 404 ? 'Recurso no encontrado.' :
          status === 500 ? 'Error del servidor. Intenta nuevamente.' :
          'Error de red. Verifica tu conexión.';
        dispatch(setDeleteVersionById({ status: 'danger', error: true, message }));
      });
  };
};

export const setDeleteVersionById = (data) => ({
  type: types.bmDeleteVersionById,
  payload: data,
});
